import { onBeforeUnmount, watch } from 'vue';
import type { Ref } from 'vue';
import type { IBetBuilderRecommendation } from '@/interface/IBetBuilderRecommendation';
import { useBetBuilderHub } from '@/libraries/recommendation/useBetBuilderHub';

export async function useBetBuilderConnection(
    combinationKey: string,
    onDataUpdated: (payload: IBetBuilderRecommendation) => void,
    onDeleted: () => void,
    isEnable: Ref<boolean>,
) {
    const { subscribe: _subscribe, unsubscribe: _unsubscribe } = useBetBuilderHub();

    const callbacks = {
        onUpdate: onDataUpdated,
        onDelete: onDeleted,
    };

    let pendingSubscribe: Promise<void> = Promise.resolve();

    onBeforeUnmount(async () => {
        await pendingSubscribe;
        await _unsubscribe(combinationKey, callbacks);
    });

    watch(isEnable, async (enabled) => {
        if (enabled) {
            await subscribe();
        } else {
            await unSubscribe();
        }
    });

    if (isEnable.value) {
        pendingSubscribe = _subscribe(combinationKey, callbacks);
        await pendingSubscribe;
    }

    async function unSubscribe() {
        await pendingSubscribe;
        await _unsubscribe(combinationKey, callbacks);
    }

    async function subscribe() {
        pendingSubscribe = _subscribe(combinationKey, callbacks);
        await pendingSubscribe;
    }
}
